<template>
  <Tooltip
    class="ml-1 flex"
    text="One-time fee charged by the Venue Manager to cover the cost of cleaning their venue."
  >
    <InfoCircleIcon class="mr-2 w-5 h-5 text-grey-800 ml-0" />
  </Tooltip>
</template>

<script>
import InfoCircleIcon from '@tagvenue/icons/24/line/general/info-circle.svg';

import Tooltip from './Tooltip.vue';

export default {
  name: 'CleaningFeeTooltip',
  components: { Tooltip, InfoCircleIcon },
};
</script>
